import { createSlice } from '@reduxjs/toolkit';
import { showAlert } from './overlaySlice';
import i18n from '../i18n';
import { t } from '@lingui/macro';

export const slice = createSlice({
  name: 'tutorial',
  initialState: {
    isRunning: false,
  },
  reducers: {
    setTutorialRunning: (state, { payload }) => {
      state.isRunning = payload;
    }
  },
});

export const { setTutorialRunning } = slice.actions;
export const endTutorial = () => (dispatch, getState) => {
  localStorage.setItem("tutorial-seen", true);
  dispatch(setTutorialRunning(false));
};

export const showGameBasicsAlert = () => (dispatch, getState) => {
  dispatch(showAlert({
    canEsc: true,
    alertType: "log",
    alertTitle: i18n._(t`Game Basics`),
    alertText: [
      i18n._(t`If you drop to 0 health, you lose`),
      i18n._(t`To win, reach 20 stars or be the last one standing`),
      i18n._(t`You have to roll your dice every turn, and can re-roll any dice you don't like up to two times per turn. The dice let you regain health, damage others, get stars, or receive energy`),
      i18n._(t`Your monster will enter the town after you roll your dice, provided there is any vacant spot in it or a player yields`),
      i18n._(t`Monsters inside the town can only deal damage to monsters outside the town, and vice versa`),
      i18n._(t`Monsters inside the town won't be healed by dice`),
      i18n._(t`You can only leave the town if you have been damaged; starting your turn in it will earn you 2 Stars`),
    ],
    alertButtons: [
      {
        content: i18n._(t`RESTART TUTORIAL`),
        action: setTutorialRunning(true),
      },
      {
        content: i18n._(t`CONTINUE PLAYING`),
        action: null,
      },
    ],
  }));
};

export const endTutorialDialog = () => (dispatch, getState) => {
  dispatch(endTutorial());
  dispatch(showAlert({
    canEsc: false,
    alertType: "log",
    alertTitle: i18n._(t`That's it!`),
    alertText: i18n._(t`That's all we have for the tutorial. We'll now show you a quick summary in case you missed something.
              You can access this summary any time by clicking on the book at the top of the town!`),
    alertButtons: [
      {
        content: i18n._(t`SEE SUMMARY`),
        action: 'showGameBasicsAlert',
      },
    ],
  }));
}

export const startTutorial = () => (dispatch, getState) => {
  dispatch(showAlert({
    canEsc: false,
    alertType: "log",
    alertTitle: i18n._(t`Welcome!`),
    alertText: i18n._(t`Welcome to King of the Town! Since this is the first time you're playing, at least as far as we can tell,
       we would like to introduce you to the game interface and the basic game rules. Should we jump into it?`),
    alertButtons: [
      {
        content: i18n._(t`I NEED NO HELP`),
        action: 'endTutorial',
      },
      {
        content: i18n._(t`LET'S GO!`),
        action: setTutorialRunning(true),
      }
    ],
  }));
};

export const selectIsTutorialRunning = state => state.tutorial.isRunning;
export default slice.reducer;
